export const JOB_TITLE_STORE = 'JOB_TITLE_STORE';
export const JOB_TITLE_UPDATE = 'JOB_TITLE_UPDATE';
export const JOB_TITLE_DESTROY = 'JOB_TITLE_DESTROY';
